import React from 'react';
import { CheckIcon } from 'lucide-react';
import { OrderStage } from '../types';
interface ProgressTrackerProps {
  stages: OrderStage[];
}
export function ProgressTracker({
  stages
}: ProgressTrackerProps) {
  return <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-5 overflow-hidden" data-id="element-89">
      <h2 className="text-sm font-semibold text-slate-900 mb-5" data-id="element-90">
        Order Progress
      </h2>

      <div className="relative" data-id="element-91">
        <div className="overflow-x-auto pb-2 -mx-5 px-5 hide-scrollbar" data-id="element-92">
          <div className="min-w-[700px]" data-id="element-93">
            {/* Background track line */}
            <div className="absolute top-[14px] left-5 right-5 h-0.5 bg-slate-200" data-id="element-94" />

            <div className="flex items-start justify-between relative" data-id="element-95">
              {stages.map((stage, index) => {
              const isCompleted = stage.status === 'completed';
              const isCurrent = stage.status === 'current';
              const isLast = index === stages.length - 1;
              // Calculate if the next stage is also completed for the green line
              const nextIsCompleted = index < stages.length - 1 && stages[index + 1].status === 'completed';
              const nextIsCurrent = index < stages.length - 1 && stages[index + 1].status === 'current';
              return <div key={stage.id} className="relative flex flex-col items-center flex-1" data-id="element-96">
                    {/* Green connecting line for completed stages */}
                    {isCompleted && (nextIsCompleted || nextIsCurrent) && <div className="absolute top-[14px] left-1/2 w-full h-0.5 bg-emerald-500 z-[1]" data-id="element-97" />}

                    {/* Circle Indicator */}
                    <div className={`relative z-[2] flex h-7 w-7 items-center justify-center rounded-full mb-2.5 transition-all ${isCompleted ? 'bg-emerald-500 text-white shadow-sm' : isCurrent ? 'bg-amber-50 border-2 border-amber-400 text-amber-600 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]' : 'bg-white border-2 border-slate-200 text-slate-400'}`} data-id="element-98">
                      {isCompleted ? <CheckIcon className="h-3.5 w-3.5" data-id="element-99" /> : <div className={`h-2 w-2 rounded-full ${isCurrent ? 'bg-amber-500 animate-pulse' : 'bg-slate-300'}`} data-id="element-100" />}
                    </div>

                    {/* Label */}
                    <div className="text-center px-1 max-w-[90px]" data-id="element-101">
                      <p className={`text-[11px] font-medium leading-tight ${isCurrent ? 'text-slate-900 font-semibold' : isCompleted ? 'text-slate-600' : 'text-slate-400'}`} data-id="element-102">
                        {stage.name}
                      </p>
                      {stage.date && <p className="text-[10px] text-slate-400 mt-0.5 leading-tight" data-id="element-103">
                          {stage.date}
                        </p>}
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </div>;
}